// extracted by mini-css-extract-plugin
module.exports = {"container":"RDFrokBreacrumbs_container__bpa4R","link":"RDFrokBreacrumbs_link__3sA6i","icon":"RDFrokBreacrumbs_icon__NhMQw"};